export default {
    DEFAULT_LANGUAGE: 'fa',
    FALLBACK_LANGUAGE: 'en',
    SUPPORTED_LANGUAGES: ['en', 'fa'],
}